import * as React from "react"
import { cn } from "../../lib/utils"
import { useBranding } from "../../contexts/BrandingContext"
import { getInputClasses } from "../../utils/brandingUtils"

const Input = React.forwardRef(({ className, type, hasError = false, ...props }, ref) => {
  const { branding } = useBranding();
  const inputClasses = getInputClasses(branding, hasError);
  
  return (
    <input
      type={type}
      className={cn(inputClasses, className)}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
